import { Box } from "@mui/material";
import { DetailedCardAccordion } from "../DetailedCardAccordion/DetailedCardAccordion";
import { StyledTypography } from "./styles";
import { formatDate } from "../../../../Utils/format-date";
import { useTranslation } from "react-i18next";
import { useAuthStore } from "../../../../Stores/useAuthStore";

interface InterviewCardListProps {
  interviews: Interview[];
  descriptions: { [key: string]: string };
  onDescriptionChange: (title: string, description: string) => void;
}

export const InterviewCardList: React.FC<InterviewCardListProps> = ({
  interviews,
  descriptions,
  onDescriptionChange,
}) => {
  const { user } = useAuthStore();
  const { t } = useTranslation();
  const notOccurred = t('common.not_occurred');

  const canSeeInterviewDescription = (interview: Interview) =>
    ['P&T', 'Internal Client'].includes(interview.title ?? '');

  return (
    <div>
      <Box display="flex" flexDirection="column" gap={1.5}>
        {interviews.map((interview) => {
          const interviewTitle = interview.title ?? '';
          const formattedDate = interview.date ? formatDate(interview.date) : notOccurred;
          const userName = interview.user ? `by ${interview.user.fullName}` : '';
          const title = `${interviewTitle} - ${formattedDate} ${userName}`;

          return canSeeInterviewDescription(interview) ? (
            <DetailedCardAccordion
              key={interview.id}
              editable={user?.isAdmin || user?.isRecruiter}
              title={title}
              editDescription={descriptions[interviewTitle] || ''}
              setEditDescription={(description) =>
                onDescriptionChange(interviewTitle, description)
              }
            />
          ) : (
            <StyledTypography key={interview.id}>
              {title}
            </StyledTypography>
          );
        })}
      </Box>
    </div>
  );
};
